import { render } from "./NavMessages.vue?vue&type=template&id=a52ecede&scoped=true"
const script = {}

import "./NavMessages.vue?vue&type=style&index=0&id=a52ecede&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a52ecede"]])

export default __exports__